<template>
  <div>
    <b-modal id="staffPosition" title="Staff Position" size="lg">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Staff Position
        </div>
      </template>

      <div class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="form-group" v-for="(staff, index) in selectedStaffs" :key="'staff_' + index">
          <label class="form-label">{{ staff['name'] }}</label>
          <multiselect
            v-model="data[staff['id']]"
            :options="positions"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option }}</template>
          </multiselect>
        </div>

      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "staffPosition",
  data() {
    return {
      showLoading: false,
      outlets: [],
      positions: ['Professional', 'Senior Stylist', 'Junior Stylist', 'Assistant', 'Trainee'],
      staffs: [],
      selectedStaffs: [],

      selectedOutlet: {},
      data: {},
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('staffPosition')
      this.loadStaff()
    },

    onOutletChange() {
      this.selectedStaffs = []
      for (let staff of this.staffs) {
        if (this.selectedOutlet.id === staff['outletID']) {
          this.selectedStaffs.push({ id: staff['staffID'], name: staff['name'] + ' - ' + staff['mobile'], outletID: staff['outletID'] })
        }
      }

      this.data = {}
      this.loadCommission()
    },

    loadStaff() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://staff.tunai.io/business/staff',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.staffs = response.data.staffs
          this.onOutletChange()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_OrientalSpa_fixedCommission_staff_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_OrientalSpa_fixedCommission_staff_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.data = response.data
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    save() {
      this.showLoading = true

      let request = {}
      for (let key in this.data) {
        request[key] = this.data[key]
      }

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_OrientalSpa_fixedCommission_staff_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_OrientalSpa_fixedCommission_staff_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('staffPosition')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}
</style>